import { createSelector } from "reselect";
const selector = (state) => state.permissions;

export default createSelector([selector], (data) => data);